module.exports = __webpack_public_path__ + "static/media/sign-up.f2624c40.png";